import produce from 'immer';
import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { OpsState } from '../types/ops.d';

const store = (set): OpsState => ({
    cost: '',
    hotspotEditMode: false,
    setHotspotEditMode: (value: boolean) => {
        set(
            produce((state: OpsState) => {
                state.hotspotEditMode = value;
            })
        );
    }
});

export const useOpsStore = create<OpsState>(devtools(store));
